export default __webpack_public_path__ + "static/media/sastabazar.e75ff0d2.PNG";